<template>
  <div class="pdf-wrapper">
    <!-- PDF展示部分 -->
    <div class="pdf-content">
      <div class="pdf-contain">
        <pdf
          class="pdf-show"
          :src="pdfUrl"
          :page="pageNum"
          @progress="loadedRatio = $event"
          @page-loaded="pageLoaded($event)"
          @num-pages="pageTotalNum = $event"
          @error="pdfError($event)"
          @link-clicked="page = $event"
        />
      </div>
    </div>
    <!-- 按钮部分 -->
    <div class="tools">
      <el-button
        type="default"
        @click="prePage"
        class="pdf-button"
      >
        上一页
      </el-button>
      <!-- 页码 -->
      <div class="page">{{ pageNum }}/{{ pageTotalNum }}</div>
      <el-button
      type="default"
        @click="nextPage"
        class="pdf-button"
      >
        下一页
      </el-button>
    </div>
  </div>
</template>
<script>
import pdf from 'vue-pdf'
export default {
  name: 'PdfViewer',
  components: {pdf},
  props: {
    url: {
      type: String,
      required: true
    }
  },
  watch: {
    url: {
      handler (val) {
        if (val) {
          this.pdfUrl = val
        }
      },
      immediate: true
    }
  },
  created () {
  },
  data () {
    return {
      pageTotalNum: 1,
      pdfUrl: '',
      pageNum: 1,
      // 加载进度
      loadedRatio: 0,
      curPageNum: 0,
      numPages: 0
    }
  },
  mounted () {
    // this.getNumPages()
  },
  methods: {
    // 计算pdf页码总数
    getNumPages (url) {
      const loadingTask = pdf.createLoadingTask(url)
      loadingTask
        .then((pdf) => {
          this.pdfUrl = loadingTask
          this.pageTotalNum = pdf.numPages
        })
    },
    // 上一页函数，
    prePage () {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },
    // 下一页函数
    nextPage () {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    },
    // 页面加载回调函数，其中e为当前页数
    pageLoaded (e) {
      this.curPageNum = e
    },
    // 其他的一些回调函数。
    pdfError (error) {
      console.error(error)
    }
  }
}
</script>
<style scoped>
.pdf-wrapper {
  width: 100%;
  height:640rpx;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.pdf-wrapper span {
  width:100%;
}
.tools {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 999;
  margin-bottom: 0;
  padding-top: 2%;
}
.pdf-content {
  display: flex;
  justify-content: center;
  width: 100%;
  height:75.8vh;
  border-radius: 2px;
  overflow-x: hidden;
}
.pdf-contain {
    width: 100%;
    overflow-x: hidden;
    height: 100%;
}

.pdf-show {
  width: 100%;
  height:100%;
}
.pdf-show canvas {
    height: 100% !important;
  }
.pdf-button {
  width:10rem;
  height:48px;
  font-size: 1.2rem;
  border-radius: 2px;
  border-color:#111;
}
.pdf-button:hover{
  cursor: pointer;
  transform: scale(1.01);
  border-color:#111;
}
.page {
  font-size: 1.5rem;
  color: #111;
}

</style>



// WEBPACK FOOTER //
// src/Views/PdfViewer/Index.vue